import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MultiSelectV2 from '../MultiSelectV2';
import BaseService from 'services/BaseService';

const MultiSelectOptionsV2 = ({ onSelect, value, label, url, disabled }) => {
  const [options, setOptions] = useState([]);

  const getOptions = async () => {
    try {
      const response = await BaseService.get({ url });
      setOptions(response.data.map((o) => ({ value: o.id, label: o.label })));
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getOptions();
  }, []);

  return (
    <MultiSelectV2
      label={label}
      disabled={disabled}
      onChange={(values) => {
        onSelect(values ? values.map((v) => v.value) : null);
      }}
      defaultValue={
        options && value
          ? options
              .filter((o) => value.indexOf(o.value) > -1)
              .map((o) => ({ value: o.value, label: o.label }))
          : []
      }
      options={options}
    />
  );
};

MultiSelectOptionsV2.propTypes = {
  onSelect: PropTypes.func.isRequired,
  value: PropTypes.array,
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

MultiSelectOptionsV2.defaultProps = {
  value: undefined,
  disabled: false,
};

export default MultiSelectOptionsV2;
